import React, { Component } from 'react';
// import logo from './logo.svg';
// import './App.css';
import Game from './Game';

class App extends Component {
  render() {
    return (
      <div>
        <Game />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js